// extracted by mini-css-extract-plugin
module.exports = {"root":"MultiFormatRepositories_root__iLY8D","ui":"MultiFormatRepositories_ui__mm2J4","cards":"MultiFormatRepositories_cards__DVbOD"};